import classNames from 'classnames'
import Parallax from '../../../common/Parallax'
import './index.scss'
import ContentState from '../../../../stores/ContentState'

const Conferences = () => {
  const content = ContentState.about?.conferences

  if (!content) return <></>
  return (
    <section className="conferences">
      <div className="conferences__container">
        <div className="conferences__title">{content?.title}</div>
        <div className="conferences__list">
          {content?.list?.map((co: any, i: number) => (
            <div className={classNames('conferences__item')} key={i}>
              <a
                href={co.link}
                target="_blank"
                className={classNames(
                  'conferences__item-bg',
                  co.link.includes('#') && 'disabled-item',
                )}
              ></a>
              <Parallax
                src={co.src ? co.src : co.img}
                type={co.src ? 'video' : 'img'}
                poster={co.src ? co.img : ''}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Conferences
